
import { useFetchIssueDetailViewQuery } from "../../../slice/logdetailSlice";
import { useParams } from "react-router-dom";
import { CommonShowDocument } from "../../common/AddDocumentComponent";


const IssueDocument = ({ issue_id }) => {
  const { id } = useParams();
  const { refetch } = useFetchIssueDetailViewQuery(id);
  // //console.log()("show log hours id", id);

  return (
    <>
      <CommonShowDocument
        refetchList={refetch}
        showPath="issue/document"
        downloadPath="issue/document/download"
        deletePath="issue/document"
        type="issue"
      />
    </>
  );
};

export default IssueDocument;
